import { Music, Play } from "lucide-react";
import { useState } from "react";

function MusicCard({
  title,
  artist,
  image,
  duration,
  isUnavailable = false,
  unavailableText = "",
  onOpenDetails,
  onPlay,
}) {
  const [imageFailed, setImageFailed] = useState(false);
  const hasImage = Boolean(image) && !imageFailed;
  const availabilityText = isUnavailable ? unavailableText || "Not available in your country" : "";

  function handlePlayClick() {
    if (isUnavailable) return;
    onPlay?.();
  }

  return (
    <article
      className={`music-card glass-panel${isUnavailable ? " is-unavailable" : ""}`}
      role={onOpenDetails ? "button" : undefined}
      tabIndex={onOpenDetails ? 0 : undefined}
      onClick={() => onOpenDetails?.()}
      onKeyDown={(event) => {
        if (!onOpenDetails) return;
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpenDetails();
        }
      }}
    >
      <div className="card-image-wrap">
        {hasImage ? (
          <img src={image} alt={title} onError={() => setImageFailed(true)} />
        ) : (
          <div className="card-image-fallback" aria-label="No artwork available">
            <Music size={30} />
            <span>No Cover</span>
          </div>
        )}
        <div className="music-card-image-overlay" />
        <span className={`music-card-chip${isUnavailable ? " is-warning" : ""}`}>
          {isUnavailable ? "Restricted" : "Track"}
        </span>
        <button
          type="button"
          className="card-play-btn"
          aria-label={isUnavailable ? `${title} is unavailable in your country` : `Play ${title}`}
          disabled={isUnavailable}
          onClick={(event) => {
            event.stopPropagation();
            handlePlayClick();
          }}
        >
          <Play size={16} />
        </button>
      </div>

      <div className="music-card-content">
        <h3>{title}</h3>
        <p className="music-card-artist">{artist}</p>

        <div className="music-card-meta-row">
          <span className={`music-card-meta-pill${isUnavailable ? " is-warning" : ""}`}>
            {isUnavailable ? availabilityText : duration || "--:--"}
          </span>
        </div>
      </div>
    </article>
  );
}

export default MusicCard;
